
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { User } from '@/common/Users';

import Brand from '@/services/Brand';

import Modal from './Base.vue';
import Alert from '@/components/Global/Alert.vue';
import TextField from '@/components/Form/TextField.vue';
import SwitchField from '@/components/Form/SwitchField.vue';
import CheckBoxField from '@/components/Form/Checkbox.vue';
import SelectField from '@/components/Form/SelectField.vue';

import jQuery from 'jquery';

@Component({
	name: 'StaffOrganizationAddAdminModal',
	components: {
		Modal,
		Alert,
		TextField,
		CheckBoxField,
		SwitchField,
		SelectField,
	},
})
export default class StaffOrganizationAddAdminModal extends Vue {
	@Prop(Function) private submit!: any;
	// tslint:disable-next-line
	@Prop(String) private org_id!: string;
	@Prop(Object) private user: any;
	// tslint:disable-next-line
	@Prop(Array) private org_admins!: any;
	@Action('updateOrgAdmin', { namespace: 'Organizations' }) private updateOrgAdmin!: any;
	@Getter('clientIds', { namespace: 'Organizations' }) private clientIds: {
		[index: string]: {
			name: string;
			brand: string;
			policies: string[];
			client_id?: string;
		};
	};
	@Getter('users', { namespace: 'Organizations' }) private users: any;

	private error: boolean = false;
	private success: boolean = false;

	private Brands: object = Brand.getBrandsObject();
	private form: any = {
		email: '',
		isOrgAdmin: true,
		client_ids: [],
		user_ids: [],
		brand: '',
		org_id: this.org_id,
		sub: '',
	};

	get normalUsers() {
		return this.users.filter(user => !this.org_admins.find(oa => oa.sub === user.sub));
	}

	private created() {
		this.form.email = this.user.email;
		this.form.sub = this.user.sub;

		if (this.user.type === 'edit') {
			this.form.brand = this.user.admin.brands[0];
			this.form.client_ids = this.user.admin.client_ids || [];
			this.form.user_ids = this.user.admin.users || [];
		}
	}

	private async updateAdmin(sub, status) {
		this.error = false;
		this.success = false;

		const params = {
			orgId: this.form.org_id,
			sub: this.form.sub,
			status: 'add',
			client_ids: this.form.client_ids.join(),
			brand: this.form.brand,
			users: this.form.user_ids,
		};

		try {
			await this.updateOrgAdmin(params);
			this.success = true;
		} catch (e) {
			this.error = true;
		}
	}
}
